import { __assign } from 'tslib';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import isNil from 'lodash/isNil';

var PREFIX = "KKeycloakAutomaticAuth";
var classes = {
    title: "".concat(PREFIX, "-title"),
    subTitle: "".concat(PREFIX, "-subTitle"),
    buttonContainer: "".concat(PREFIX, "-buttonContainer"),
    button: "".concat(PREFIX, "-button"),
    helpLink: "".concat(PREFIX, "-helpLink"),
    iconLeft: "".concat(PREFIX, "-iconLeft"),
    iconRight: "".concat(PREFIX, "-iconRight")
};
var StyledKKeycloakAutomaticAuth = styled(Box)(function (_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme, adminButtonStyle = _a.adminButtonStyle, convertThemeColor = _a.convertThemeColor;
    return (__assign((_b = { paddingRight: theme.spacing(4), paddingLeft: theme.spacing(4), paddingTop: theme.spacing(2.5), paddingBottom: theme.spacing(2.5) }, _b["& .".concat(classes.title)] = {
        fontSize: "1.3rem",
        "& .KKeycloakAutomaticAuthButtonTitle": {
            marginBottom: theme.spacing(1)
        }
    }, _b["& .".concat(classes.subTitle)] = {
        fontSize: "0.9rem",
        lineHeight: "1rem",
        color: theme.palette.text.secondary,
        "& .KKeycloakAutomaticAuthButtonSubtitle": {
            marginBottom: theme.spacing(1.5)
        }
    }, _b["& .".concat(classes.buttonContainer)] = {
        marginTop: theme.spacing(1)
    }, _b["& .".concat(classes.iconLeft)] = (_c = {
            position: "absolute",
            left: theme.spacing(2.5)
        },
        _c[theme.breakpoints.down("sm")] = {
            left: theme.spacing(1)
        },
        _c), _b["& .".concat(classes.iconRight)] = (_d = {
            position: "absolute",
            right: theme.spacing(2.5)
        },
        _d[theme.breakpoints.down("sm")] = {
            right: theme.spacing(1)
        },
        _d), _b["& .".concat(classes.helpLink)] = {
        fontSize: "0.80rem",
        fontWeight: "bold",
        textDecoration: "underline",
        display: "inline-block",
        marginTop: theme.spacing(2.5)
    }, _b), (adminButtonStyle && (_e = {
            display: adminButtonStyle.width ? "flex" : "",
            flexDirection: adminButtonStyle.width ? "column" : "unset"
        },
        _e["& .".concat(classes.buttonContainer)] = {
            marginTop: theme.spacing(1),
            width: adminButtonStyle.width ? adminButtonStyle.width : "",
            alignSelf: adminButtonStyle.width ? "center" : "",
            textAlign: "center"
        },
        _e["& .".concat(classes.button)] = {
            padding: theme.spacing(1.25),
            paddingTop: !isNil(adminButtonStyle.verticalPadding)
                ? adminButtonStyle.verticalPadding
                : theme.spacing(1.25),
            paddingBottom: !isNil(adminButtonStyle.verticalPadding)
                ? adminButtonStyle.verticalPadding
                : theme.spacing(1.25),
            paddingLeft: (!adminButtonStyle.iconPosition || adminButtonStyle.iconPosition === "LEFT") &&
                theme.breakpoints.up("sm")
                ? theme.spacing(4)
                : "",
            paddingRight: adminButtonStyle.iconPosition === "RIGHT" && theme.breakpoints.up("sm")
                ? theme.spacing(4)
                : "",
            borderRadius: adminButtonStyle.borderRadius ? adminButtonStyle.borderRadius : "",
            backgroundColor: adminButtonStyle.backgroundColor
                ? convertThemeColor(adminButtonStyle.backgroundColor)
                : "",
            color: adminButtonStyle.textColor ? convertThemeColor(adminButtonStyle.textColor) : "",
            borderColor: adminButtonStyle.borderColor
                ? "".concat(convertThemeColor(adminButtonStyle.borderColor), " !important")
                : "",
            ":hover": {
                backgroundColor: adminButtonStyle.backgroundColorOnHover
                    ? convertThemeColor(adminButtonStyle.backgroundColorOnHover)
                    : adminButtonStyle.backgroundColor
                        ? convertThemeColor(adminButtonStyle.backgroundColor)
                        : "",
                color: adminButtonStyle.textColorOnHover
                    ? convertThemeColor(adminButtonStyle.textColorOnHover)
                    : "",
                ".KIcon": {
                    color: adminButtonStyle.textColorOnHover
                        ? convertThemeColor(adminButtonStyle.textColorOnHover)
                        : ""
                }
            }
        },
        _e))));
});

export { StyledKKeycloakAutomaticAuth, classes };
//# sourceMappingURL=styles.js.map
